import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1ba086b8 = () => interopDefault(import('..\\..\\..\\pages\\aboutus.vue' /* webpackChunkName: "pages/aboutus" */))
const _7bcebb59 = () => interopDefault(import('..\\..\\..\\pages\\contact.vue' /* webpackChunkName: "pages/contact" */))
const _e778696a = () => interopDefault(import('..\\..\\..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _c719d02e = () => interopDefault(import('..\\..\\..\\pages\\guideline.vue' /* webpackChunkName: "pages/guideline" */))
const _97b5b77e = () => interopDefault(import('..\\..\\..\\pages\\portfolio.vue' /* webpackChunkName: "pages/portfolio" */))
const _6a01f916 = () => interopDefault(import('..\\..\\..\\pages\\services.vue' /* webpackChunkName: "pages/services" */))
const _9db6d5ae = () => interopDefault(import('..\\..\\..\\pages\\test.vue' /* webpackChunkName: "pages/test" */))
const _0af33f22 = () => interopDefault(import('..\\..\\..\\pages\\projects\\ads.vue' /* webpackChunkName: "pages/projects/ads" */))
const _0fd5cc14 = () => interopDefault(import('..\\..\\..\\pages\\projects\\kuzu.vue' /* webpackChunkName: "pages/projects/kuzu" */))
const _0b9c5684 = () => interopDefault(import('..\\..\\..\\pages\\projects\\vc.vue' /* webpackChunkName: "pages/projects/vc" */))
const _29f63376 = () => interopDefault(import('..\\..\\..\\pages\\projects\\viewbox.vue' /* webpackChunkName: "pages/projects/viewbox" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aboutus",
    component: _1ba086b8,
    name: "aboutus___es"
  }, {
    path: "/contact",
    component: _7bcebb59,
    name: "contact___es"
  }, {
    path: "/en",
    component: _e778696a,
    name: "index___en"
  }, {
    path: "/guideline",
    component: _c719d02e,
    name: "guideline___es"
  }, {
    path: "/portfolio",
    component: _97b5b77e,
    name: "portfolio___es"
  }, {
    path: "/services",
    component: _6a01f916,
    name: "services___es"
  }, {
    path: "/test",
    component: _9db6d5ae,
    name: "test___es"
  }, {
    path: "/en/aboutus",
    component: _1ba086b8,
    name: "aboutus___en"
  }, {
    path: "/en/contact",
    component: _7bcebb59,
    name: "contact___en"
  }, {
    path: "/en/guideline",
    component: _c719d02e,
    name: "guideline___en"
  }, {
    path: "/en/portfolio",
    component: _97b5b77e,
    name: "portfolio___en"
  }, {
    path: "/en/services",
    component: _6a01f916,
    name: "services___en"
  }, {
    path: "/en/test",
    component: _9db6d5ae,
    name: "test___en"
  }, {
    path: "/projects/ads",
    component: _0af33f22,
    name: "projects-ads___es"
  }, {
    path: "/projects/kuzu",
    component: _0fd5cc14,
    name: "projects-kuzu___es"
  }, {
    path: "/projects/vc",
    component: _0b9c5684,
    name: "projects-vc___es"
  }, {
    path: "/projects/viewbox",
    component: _29f63376,
    name: "projects-viewbox___es"
  }, {
    path: "/en/projects/ads",
    component: _0af33f22,
    name: "projects-ads___en"
  }, {
    path: "/en/projects/kuzu",
    component: _0fd5cc14,
    name: "projects-kuzu___en"
  }, {
    path: "/en/projects/vc",
    component: _0b9c5684,
    name: "projects-vc___en"
  }, {
    path: "/en/projects/viewbox",
    component: _29f63376,
    name: "projects-viewbox___en"
  }, {
    path: "/",
    component: _e778696a,
    name: "index___es"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
